(function () {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (!isIOS) return;

  let tipEl = null;
  let activeOptionId = null;     
  let rafPending = false;
  let observer = null;
  let moTimer = null;

  function ensureTip() {
    if (tipEl) return tipEl;

    tipEl = document.createElement('div');
    tipEl.className =
      'cpb-ios-polaris-tooltip Polaris-PositionedOverlay cpb-option-tooltip-wrapper';
    tipEl.style.position = 'fixed';
    tipEl.style.left = '0px';
    tipEl.style.top = '0px';
    tipEl.style.transform = 'translate(-9999px, -9999px)';
    tipEl.style.zIndex = '2147483647';
    tipEl.style.display = 'none';
    tipEl.style.pointerEvents = 'none';

    tipEl.innerHTML = `
      <div class="Polaris-Tooltip" data-polaris-layer="true">
        <div class="Polaris-Tooltip__Tip"></div>
        <div class="Polaris-Tooltip__Wrapper">
          <div class="Polaris-Tooltip__Content">
            <div class="Polaris-Tooltip__Label"></div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(tipEl);
    return tipEl;
  }

  function findActiveOptionEl() {
    if (!activeOptionId) return null;

    let el = document.querySelector(
      `.cpb-option[data-option-id="${CSS.escape(activeOptionId)}"].cpb-active`
    );
    if (el) return el;

    el = document.querySelector(
      `.cpb-option[data-option-id="${CSS.escape(activeOptionId)}"]`
    );
    return el || null;
  }

  function getNamePrice(optionEl) {
    const optionRoot = optionEl.closest('.option') || optionEl;

    const name =
      optionRoot.querySelector('.cpb-option-info-label')?.textContent?.trim() ||
      optionEl.querySelector('.cpb-option-label')?.textContent?.trim() ||
      optionEl.querySelector('img')?.alt?.trim() ||
      '';

    const price =
      optionRoot.querySelector('.cpb-money')?.textContent?.trim() ||
      optionRoot
        .querySelector('[data-testid="multycurrency-price"]')
        ?.textContent?.trim() ||
      '';

    return { name, price };
  }

  function renderLabel(labelEl, name, price) {
    labelEl.innerHTML = '';

    labelEl.appendChild(document.createElement('span'));
    const sName = document.createElement('span');
    sName.textContent = name;
    labelEl.appendChild(sName);

    const sSpace = document.createElement('span');
    sSpace.textContent = ' ';
    labelEl.appendChild(sSpace);

    if (price) {
      const wrap = document.createElement('span');
      const money = document.createElement('span');
      money.className = 'cpb-money';
      money.setAttribute('data-testid', 'multycurrency-price');
      money.textContent = price;
      wrap.appendChild(money);
      labelEl.appendChild(wrap);
    }

    labelEl.appendChild(document.createElement('span'));
  }

function positionTo(optionEl) {
  const el = ensureTip();
  const rect = optionEl.getBoundingClientRect();

  if (el.style.display !== 'block') el.style.display = 'block';

  requestAnimationFrame(() => {
    const tRect = el.getBoundingClientRect();

    const anchorX = rect.left + rect.width / 2;
    const x = anchorX - tRect.width / 2;   
    const y = rect.bottom + 10;

    el.style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px)`;
  });
}

  function showOrReposition() {
    if (!activeOptionId) return;

    const optionEl = findActiveOptionEl();
    if (!optionEl) {
      hide();
      return;
    }

    const { name, price } = getNamePrice(optionEl);
    if (!name) {
      hide();
      return;
    }

    const el = ensureTip();
    const labelEl = el.querySelector('.Polaris-Tooltip__Label');
    renderLabel(labelEl, name, price);
    positionTo(optionEl);
  }

  function scheduleReposition() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      showOrReposition();
    });
  }

  function hide() {
    if (!tipEl) return;
    tipEl.style.display = 'none';
    tipEl.style.transform = 'translate(-9999px, -9999px)';
    activeOptionId = null;
  }

  function ensureObserver() {
    if (observer) return;

    const root =
      document.querySelector('#product-builder') ||
      document.querySelector('.cpb-root') ||
      document.querySelector('.cpb-layout') ||
      document.body;

observer = new MutationObserver(() => {
  if (!activeOptionId) return;
  clearTimeout(moTimer);
  moTimer = setTimeout(scheduleReposition, 60);
});

    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-pressed'],
    });
  }

  ensureObserver();

  document.addEventListener(
    'click',
    (e) => {
      const optionEl = e.target.closest('.cpb-option');
      if (!optionEl) {
        hide();
        return;
      }

      const id = optionEl.getAttribute('data-option-id');
      if (!id) return;

      activeOptionId = id;

setTimeout(() => {
  showOrReposition();
  scheduleReposition(); 
}, 0);
    },
    true
  );

  window.addEventListener('scroll', () => activeOptionId && scheduleReposition(), { passive: true });
  window.addEventListener('resize', () => activeOptionId && scheduleReposition());
})();